import { ChangeDetectionStrategy, Component, Input, OnChanges, Optional } from '@angular/core';

@Component({
    selector: 'eas-user-emails',
    templateUrl: './user-emails.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserEmailsComponent implements OnChanges {
  @Input() primaryEmail: string = '';
  @Input() @Optional() secondaryEmails: string[] = [];

  constructor(
  ) {}

  ngOnChanges() {
  }
}
